// 天干类型
export type HeavenlyStem = '甲'|'乙'|'丙'|'丁'|'戊'|'己'|'庚'|'辛'|'壬'|'癸';

// 十神类型
export type TenGodType = '比肩'|'劫财'|'食神'|'伤官'|'偏财'|'正财'|'七杀'|'正官'|'偏印'|'正印';

// 十神映射表类型
export type TenGodMap = {
  [key:string]: {
    [key:string]: TenGodType;
  };
};

const TEN_GODS: TenGodMap = {
  // 甲 (阳木) - 原版正确
  '甲': {
    '甲': '比肩', '乙': '劫财',
    '丙': '食神', '丁': '伤官',
    '戊': '偏财', '己': '正财',
    '庚': '七杀', '辛': '正官',
    '壬': '偏印', '癸': '正印'
  },
  // 乙 (阴木) - ❌ 已修正 (异性为伤/正/官/劫)
  '乙': {
    '甲': '劫财', '乙': '比肩',
    '丙': '伤官', '丁': '食神', // 修正：乙生丙为伤官
    '戊': '正财', '己': '偏财', // 修正：乙克戊为正财
    '庚': '正官', '辛': '七杀', // 修正：庚克乙为正官
    '壬': '正印', '癸': '偏印'  // 修正：壬生乙为正印
  },
  // 丙 (阳火) - 原版正确
  '丙': {
    '甲': '偏印', '乙': '正印',
    '丙': '比肩', '丁': '劫财',
    '戊': '食神', '己': '伤官',
    '庚': '偏财', '辛': '正财',
    '壬': '七杀', '癸': '正官'
  },
  // 丁 (阴火) - ❌ 已修正
  '丁': {
    '甲': '正印', '乙': '偏印', // 修正
    '丙': '劫财', '丁': '比肩',
    '戊': '伤官', '己': '食神', // 修正：丁生戊为伤官
    '庚': '正财', '辛': '偏财', // 修正：丁克庚为正财
    '壬': '正官', '癸': '七杀'  // 修正：壬克丁为正官
  },
  // 戊 (阳土) - 原版正确
  '戊': {
    '甲': '七杀', '乙': '正官', // 注意：原版此处也是对的
    '丙': '偏印', '丁': '正印',
    '戊': '比肩', '己': '劫财',
    '庚': '食神', '辛': '伤官',
    '壬': '偏财', '癸': '正财'
  },
  // 己 (阴土) - ❌ 已修正
  '己': {
    '甲': '正官', '乙': '七杀', // 修正：甲克己为正官
    '丙': '正印', '丁': '偏印', // 修正
    '戊': '劫财', '己': '比肩',
    '庚': '伤官', '辛': '食神', // 修正：己生庚为伤官
    '壬': '正财', '癸': '偏财'  // 修正：己克壬为正财
  },
  // 庚 (阳金) - 原版正确
  '庚': {
    '甲': '偏财', '乙': '正财',
    '丙': '七杀', '丁': '正官',
    '戊': '偏印', '己': '正印',
    '庚': '比肩', '辛': '劫财',
    '壬': '食神', '癸': '伤官'
  },
  // 辛 (阴金) - ❌ 已修正
  '辛': {
    '甲': '正财', '乙': '偏财', // 修正
    '丙': '正官', '丁': '七杀', // 修正
    '戊': '正印', '己': '偏印', // 修正
    '庚': '劫财', '辛': '比肩',
    '壬': '伤官', '癸': '食神'  // 修正：辛生壬为伤官
  },
  // 壬 (阳水) - ❌ 已修正 (原版全反了)
  '壬': {
    '甲': '食神', '乙': '伤官', // 修正：壬生甲为食神 (同性)
    '丙': '偏财', '丁': '正财', // 修正：壬克丙为偏财 (同性)
    '戊': '七杀', '己': '正官', // 修正：戊克壬为七杀 (同性)
    '庚': '偏印', '辛': '正印', // 修正
    '壬': '比肩', '癸': '劫财'
  },
  // 癸 (阴水) - 原版是对的 (除了壬，你这里写对了)
  '癸': {
    '甲': '伤官', '乙': '食神',
    '丙': '正财', '丁': '偏财',
    '戊': '正官', '己': '七杀',
    '庚': '正印', '辛': '偏印',
    '壬': '劫财', '癸': '比肩'
  }
};

export const getTenGod = (dayHeavenlyStem: string, targetHeavenlyStem: string): TenGodType => {
  return TEN_GODS[dayHeavenlyStem][targetHeavenlyStem];
};